/*
 * 入口文件
 * @Author: hai-27
 * @Date: 2020-02-07 16:23:00
 * @LastEditors: hai-27
 * @LastEditTime: 2020-03-04 23:38:41
 */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
const app = createApp(App)

import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
app.use(ElementPlus);

import * as ElementPlusIconsVue from '@element-plus/icons-vue'
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 全局函数及变量
app.config.globalProperties.$target = "http://106.15.179.105:3000/"; // 线上后端地址
// 封装提示成功的弹出框
app.config.globalProperties.notifySucceed = function (msg) {
  this.$notify({
    title: "成功",
    message: msg,
    type: "success",
    offset: 100
  });
};
// 封装提示失败的弹出框
app.config.globalProperties.notifyError = function (msg) {
  this.$notify.error({
    title: "错误",
    message: msg,
    offset: 100
  });
};

// import Axios from 'axios';
// app.config.globalProperties.$axios = Axios;
// // 全局请求拦截器
// Axios.interceptors.request.use(
//   config => {
//     return config;
//   },
//   error => {
//     // 跳转error页面
//     router.push({ path: "/error" });
//     return Promise.reject(error);
//   }
// );
// // 全局响应拦截器
// Axios.interceptors.response.use(
//   res => {
//     if (res.data.code === "401") {
//       // 401表示没有登录
//       // 提示没有登录
//       app.prototype.notifyError(res.data.msg);
//       // 修改vuex的showLogin状态,显示登录组件
//       store.dispatch("setShowLogin", true);
//     }
//     if (res.data.code === "500") {
//       // 500表示服务器异常
//       // 跳转error页面
//       router.push({ path: "/error" });
//     }
//     return res;
//   },
//   error => {
//     // 跳转error页面
//     router.push({ path: "/error" });
//     return Promise.reject(error);
//   }
// );

// 全局拦截器,在进入需要用户权限的页面前校验是否已经登录
router.beforeResolve((to, from, next) => {
  const loginUser = store.state.user.user;
  // 判断路由是否设置相应校验用户权限
  if (to.meta.requireAuth) {
    if (!loginUser) {
      // 没有登录，显示登录组件
      store.dispatch("setShowLogin", true);
      if (from.name == null) {
        //此时，是在页面没有加载，直接在地址栏输入链接，进入需要登录验证的页面
        next("/");
        return;
      }
      // 终止导航
      next(false);
      return;
    }
  }
  next();
});

// 相对时间过滤器,把时间戳转换成时间
// 格式: 2020-02-25 21:43:23
app.config.globalProperties.filter = ('dateFormat', (dataStr) => {
  var time = new Date(dataStr);
  function timeAdd0(str) {
    if (str < 10) {
      str = '0' + str;
    }
    return str;
  }
  var y = time.getFullYear();
  var m = time.getMonth() + 1;
  var d = time.getDate();
  var h = time.getHours();
  var mm = time.getMinutes();
  var s = time.getSeconds();
  return y + '-' + timeAdd0(m) + '-' + timeAdd0(d) + ' ' + timeAdd0(h) + ':' + timeAdd0(mm) + ':' + timeAdd0(s);
});

import LoadingPlugin from './utils/loading'
app.use(LoadingPlugin)

//全局组件
import MyMenu from './components/MyMenu';
app.component(MyMenu.name, MyMenu);
import MyList from './components/MyList';
app.component(MyList.name, MyList);
import MyLogin from './components/MyLogin';
app.component(MyLogin.name, MyLogin);
import MyRegister from './components/MyRegister';
app.component(MyRegister.name, MyRegister);

app.config.productionTip = false;

app.use(router)
app.use(store)
app.mount('#app')
